import { render, staticRenderFns } from "./CartRecap.vue?vue&type=template&id=6a56c289"
import script from "./CartRecap.vue?vue&type=script&lang=ts"
export * from "./CartRecap.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports